// removed by extract-text-webpack-plugin
module.exports = {"FeedbackContainer":"_3z3jW2c13IlJwPmCqhEvm8","HeaderText":"HH1eIdateRYWjsHxWB0X2","Icon":"_282zPHC58hmtmaQDvsxIpJ","ArrowIcon":"_3vG1154BqlplPlgLXSx0g3","IconSmiley":"ISfjp_2wS3T_7DfH549wK","ButtonContainer":"_1SKp5wo6LFvM14eJ3IZUMS","FeedbackItem":"q9hqQ8YZrKf5BQC2ioOby","SmileyNumbers":"_34OvxrFYicz_pJi233bGYg","Question":"_3fkUWP-EdVf0uTebkYHNi7","NumberUnread":"_1vc_wym48JM7V5FoAKYDJd","HintIcon":"_18HtMezkLaAiytqotcfbfj"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Overview/Feedback/style.css
// module id = 2422
// module chunks = 0